export default "__VITE_ASSET__79878d32__"